import { useEffect, useState } from 'react'
import {
	BackgroundRemoverLogo,
	CreatePostIcon,
	CrossIcon,
	EmptyAlbumIcon,
	LeftArrowIcon,
	PixelsBlockLogo,
	PixelsLogo,
	RightArrowIcon,
	SearchIcon,
	UploadImageIcon,
	LogoWithoutText,
	SingleTickIcon,
	CloseMinusIcon,
	BulletIcon,
	PostGenerationIcon,
} from '../icons'
import { Modal } from '../util'
import { ModalPropsI } from '../util/modal'

interface PhotosI {
	photo1: {
		imgURL: string
	}
	photo2: {
		imgURL: string
	}
	photoBGRemoverModal: {
		imgURL: string
	}
}

export const ProductAndServiceImages: React.FC = () => {
	//local states
	const [photo, setPhoto] = useState<PhotosI>({
		photo1: { imgURL: '' },
		photo2: { imgURL: '' },
		photoBGRemoverModal: { imgURL: '' },
	})
	const [open, setOpen] = useState<boolean>(false)
	const [
		minimizePostGenerationBox,
		setMinimizePostGenerationBox,
	] = useState<boolean>(false)
	const [
		openPostGenerationModal,
		setOpenPostGenerationModal,
	] = useState<boolean>(false)
	const [
		openBackGroundRemoverModal,
		setOpenBackGroundRemoverModal,
	] = useState<boolean>(false)

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		console.log(e.currentTarget.files)
		const file = e.currentTarget.files && e.currentTarget.files[0]
		const photoNewObj = Object.assign(file, {
			imgURL: URL.createObjectURL(file),
		})
		setPhoto({
			...photo,
			[e.currentTarget.name]: photoNewObj,
		} as PhotosI)
	}

	//pixels image modal component
	const PixelsModal: React.FC<ModalPropsI> = ({ open, onClick }) => (
		<Modal open={open} onClick={onClick}>
			<section className='pixel-images-modal'>
				<section className='header'>
					<PixelsBlockLogo />
					<section className='input-section'>
						<input type='text' placeholder='Search for free photos' />
						<div>
							<SearchIcon />
						</div>
					</section>
					<section className='texts'>
						<h3>Free Stock Images</h3>
						<p>
							You can search free stock images and use it on your ad creatives.
						</p>
					</section>
				</section>
				<section className='pixel-images-grid'>
					{imagesDummyURLs.map((pic, i) => (
						<section key={i} className='card'>
							<img src={pic} alt='cardsgrid' />
							<div>
								<p>Select Picture</p>
							</div>
						</section>
					))}
				</section>
			</section>
		</Modal>
	)

	//pixels image modal component
	const BackgroundRemoversModal: React.FC<ModalPropsI> = ({
		open,
		onClick,
	}) => (
		<Modal open={open} onClick={onClick}>
			<section className='background-remover-modal'>
				<BackgroundRemoverLogo />
				<h1>Background Remover</h1>
				<p>
					If the photo is not transparent, use our background removal option.
				</p>
				<section className='image-upload-section'>
					{photo.photoBGRemoverModal.imgURL ? (
						<div className='upload-image-section'>
							<img
								src={photo.photoBGRemoverModal.imgURL}
								alt='photoBGRemoverModal'
							/>
							<div>
								<CrossIcon
									onClick={() =>
										setPhoto({
											...photo,
											photoBGRemoverModal: { imgURL: '' },
										} as PhotosI)
									}
								/>
							</div>
						</div>
					) : (
						<label
							className='upload-image-section'
							htmlFor='upload-photoBGRemoverModal'>
							<p>Click Here to Upload Logo!</p>
						</label>
					)}
					<input
						type='file'
						accept='image/*'
						onChange={onChangeHandler}
						id='upload-photoBGRemoverModal'
						name='photoBGRemoverModal'
					/>
				</section>
				{photo.photoBGRemoverModal.imgURL && (
					<section className='button-section'>
						<button>
							<p>
								Use thıs <b>(+1 Credit)</b>
							</p>
							<RightArrowIcon />
						</button>
					</section>
				)}
			</section>
		</Modal>
	)

	//generation post modal
	const GenerationPosts: React.FC = () => (
		<section className='generation-posts'>
			<section className='content'>
				<section className='texts'>
					<LogoWithoutText />
					<h1>Your creatives are being generated!</h1>
					<p>
						You can check your projects and generate other ones while waiting.
					</p>
				</section>
				{minimizePostGenerationBox ? (
					<section className='post-generation-minimized-box'>
						<h3>Post Generation</h3>
						<div onClick={() => setMinimizePostGenerationBox(false)}>
							<PostGenerationIcon />
						</div>
					</section>
				) : (
					<section className='post-generation-box'>
						<section className='nav'>
							<CloseMinusIcon
								onClick={() => setMinimizePostGenerationBox(true)}
							/>
						</section>
						<h3>Post Generation</h3>
						<ul>
							<li>
								<BulletIcon /> Our A.I. is reading your data <SingleTickIcon />
							</li>
							<li>
								<BulletIcon />
								Best Practices are applied <SingleTickIcon />
							</li>
							<li>
								<BulletIcon />
								Conversion rate optimization is applied <SingleTickIcon />
							</li>
							<li>
								<BulletIcon />
								Creatives are being generated
								<SingleTickIcon />
							</li>
							<li>
								<BulletIcon />
								Creatives are ready to be downloaded
								<SingleTickIcon />
							</li>
						</ul>
						<section className='button'>
							<CreatePostIcon /> GO TO GENERATED CREATIVES <RightArrowIcon />
						</section>
						<section className='progress-bar-container'>
							<div className='progress-bar' />
						</section>
					</section>
				)}
			</section>
		</section>
	)

	return (
		<>
			{openPostGenerationModal && <GenerationPosts />}
			<div className='product-and-service-images'>
				<h5>ADYOUNEED Branding</h5>
				<h1>Product&Service Images</h1>
				<p>
					Upload any images for your product\service or select from Pexel
					without leaving AdCreative.AI
				</p>
				<section className='cards-grid-images'>
					<section className='background-images'>
						<section className='content'>
							<section className='left-area'>
								<UploadImageIcon />
								<h4>Upload Image</h4>
							</section>
						</section>
						<section className='images-cards-grid'>
							<section className='pixels-images-background'>
								<h5>Background</h5>
								<small>
									<b>Choose a background image for your post design</b>
								</small>
								<section className='image-button-section'>
									<section className='image-upload-section'>
										{photo.photo1.imgURL ? (
											<div className='upload-image-section'>
												<img src={photo.photo1.imgURL} alt='photo1' />
												<div>
													<CrossIcon
														onClick={() =>
															setPhoto({
																...photo,
																photo1: { imgURL: '' },
															} as PhotosI)
														}
													/>
												</div>
											</div>
										) : (
											<label
												className='upload-image-section'
												htmlFor='upload-photo1'>
												<p>Click Here to Upload Logo!</p>
											</label>
										)}
										<input
											type='file'
											accept='image/*'
											onChange={onChangeHandler}
											id='upload-photo1'
											name='photo1'
										/>
									</section>
									<section className='button-section'>
										<button onClick={() => setOpen(true)}>
											<PixelsLogo />
											Image Search Engine
										</button>
									</section>
								</section>
								<PixelsModal open={open} onClick={() => setOpen(!open)} />
							</section>
							<section className='background-remover'>
								<h5>Product (Optional)</h5>
								<small>
									<b>
										If the photo is not transparent, use our background removal
										option.
									</b>
								</small>
								<section className='image-button-section'>
									<section className='image-upload-section'>
										{photo.photo2.imgURL ? (
											<div className='upload-image-section'>
												<img src={photo.photo2.imgURL} alt='photo2' />
												<div>
													<CrossIcon
														onClick={() =>
															setPhoto({
																...photo,
																photo2: { imgURL: '' },
															} as PhotosI)
														}
													/>
												</div>
											</div>
										) : (
											<label
												className='upload-image-section'
												htmlFor='upload-photo2'>
												<p>Click Here to Upload Logo!</p>
											</label>
										)}
										<input
											type='file'
											accept='image/*'
											onChange={onChangeHandler}
											id='upload-photo2'
											name='photo2'
										/>
									</section>
									<section className='button-section'>
										<button onClick={() => setOpenBackGroundRemoverModal(true)}>
											<BackgroundRemoverLogo />
											<span>
												<b>Background</b> <br /> Remover
											</span>
										</button>
									</section>
								</section>
								<BackgroundRemoversModal
									open={openBackGroundRemoverModal}
									onClick={() =>
										setOpenBackGroundRemoverModal(!openBackGroundRemoverModal)
									}
								/>
							</section>
						</section>
					</section>
					<section className='text-view'>
						{photo.photo1.imgURL && (
							<img
								className='background-img'
								src={photo.photo1.imgURL}
								alt='photo2'
							/>
						)}
						<section
							className='all-main-content'
							style={{
								backgroundColor: photo.photo1.imgURL
									? 'transparent'
									: '#edeaf5',
							}}>
							<EmptyAlbumIcon />
							<>
								<h4>THE AD GRAPHICS YOU NEED AND CONVERT</h4>
								<small>
									Create converting ad graphics in a few clicks with
									AdCreative.ai
								</small>
							</>
							<section className='button-section'>
								<button>Button Text</button>
							</section>
							<p>This is just the preview window.</p>
						</section>
					</section>
				</section>
				<section className='buttons-section'>
					<section className='back-button-section'>
						<button>
							<LeftArrowIcon />
							Go Back
						</button>
					</section>
					<section className='continue-button-section'>
						<button onClick={() => setOpenPostGenerationModal(true)}>
							<CreatePostIcon /> CREATE A POSTS <RightArrowIcon />
						</button>
					</section>
				</section>
			</div>
		</>
	)
}

const imagesDummyURLs = [
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
	'./pix.jpg',
]
